import { createSelector } from 'reselect';

import { getActiveFilterCards } from 'src/universal/redux/cardsFilter';
import { getPageCardsData } from 'src/universal/redux/page';
import replaceStringWithVars from 'src/universal/utils/replaceStringWithVars';
import { getPageData } from 'src/universal/redux/page';

export const getCardListOrderData = createSelector(
  [getPageData, getActiveFilterCards, getPageCardsData],
  ({ cardListCarousel }, cardNameList, allCards) => {
    const dtm = (cardListCarousel?.dtmEvents || []).find(
      dtm => dtm.key === 'horizontalTileClick'
    );

    const cardList = allCards.reduce((accumulator, card) => {
      const shouldShow = cardNameList.indexOf(card.shortName) > -1;
      if (shouldShow) {
        accumulator.push({
          cardTitle: card.cardTitle,
          cardArtUrl: card.appAssets?.cardArt,
          cardArtAltText: card.cardArtAltText,
          learnMoreUrl: card.learnMore?.url,
          shortName: card.shortName,
          unitDtm: {
            ...(dtm || {}),
            eventAsset: replaceStringWithVars({
              varsObject: { product: card.dtmProductName },
              string: dtm.eventAsset
            }),
            tag: replaceStringWithVars({
              varsObject: { product: card.dtmProductName },
              string: dtm.tag
            })
          }
        });
      }
      return accumulator;
    }, []);

    const baseDtm = (cardListCarousel?.dtmEvents || []).find(
      dtm => dtm.key === 'horizontalTileImpression'
    );
    const cardImpressionEventMap = (allCards || []).reduce((accumulator, card) => {
      accumulator[card.shortName] = {
        ...baseDtm,
        eventAsset: replaceStringWithVars({
          varsObject: { product: card.dtmProductName },
          string: baseDtm.eventAsset
        })
      };
      return accumulator;
    }, {});
    return {
      cardListCarousel,
      cardList,
      cardImpressionEventMap
    };
  }
);
